import { Button, Row, Space } from "antd";
import React, { useState } from "react";
import { CourseModal, AddBatchModal } from "./modal";
import Table from "./table";

const CourseTab = (props) => {
  const [addVisible, setAddVisible] = useState(false);
  const [addVisible2, setAddVisible2] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const onSuccess = () => setRefreshKey((k) => k + 1);
  return (
    <>
      <CourseModal addVisible={addVisible} setAddVisible={setAddVisible} onSuccess={onSuccess} />
      <AddBatchModal
        addVisible={addVisible2}
        setAddVisible={setAddVisible2}
        onSuccess={onSuccess}
      />
      <Row justify="center">
        <Space size="large">
          <Button type="primary" onClick={() => setAddVisible(true)}>
            Add Course
          </Button>
          <Button type="danger" onClick={() => setAddVisible2(true)}>
            Add Batches to Course
          </Button>
        </Space>
      </Row>
      <Table refreshKey={refreshKey} />
    </>
  );
};

export default CourseTab;
